import {
  GoabContainer,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
  GoabSpacer,
} from "@abgov/react-components";

import { useGenerationForm, useSessionManagement } from "../../hooks";

import FirstNationStatusDetail from "../../../../../MPP-Common-SPA/Widgets/FNIM/FirstNationStatusDetail";

export const FirstNationsSection = () => {
  const { form, fieldValues, handleChange } =
    useGenerationForm("FirstNationStatus");

  const { getResourceValue } = useSessionManagement();

  // First nations status form wrapper
  const firstNationStatusForm = {
    values: {
      band: form.values.FirstNationStatus?.band || "",
      family: form.values.FirstNationStatus?.family || "",
      position: form.values.FirstNationStatus?.position || "",
      FNIHB: form.values.FirstNationStatus?.FNIHB || "",
    },
    errors: {
      band: (form.errors.FirstNationStatus as any)?.band,
      family: (form.errors.FirstNationStatus as any)?.family,
      position: (form.errors.FirstNationStatus as any)?.position,
      FNIHB: (form.errors.FirstNationStatus as any)?.FNIHB,
    },
    touched: {
      band: (form.touched?.FirstNationStatus as any)?.band,
      family: (form.touched?.FirstNationStatus as any)?.family,
      position: (form.touched?.FirstNationStatus as any)?.position,
      FNIHB: (form.touched?.FirstNationStatus as any)?.FNIHB,
    },
    setFieldValue: (name: string, value: any) => {
      form.setFieldValue(`FirstNationStatus.${name}`, value);
    },
    setFieldTouched: (name: string, touched: boolean = true) => {
      form.setFieldTouched(`FirstNationStatus.${name}`, touched);
    },
    setValues: (values: any) => {
      const fieldsToSet = ["band", "family", "position", "FNIHB"];
      fieldsToSet.forEach((field) => {
        if (values[field] !== undefined) {
          form.setFieldValue(`FirstNationStatus.${field}`, values[field]);
        }
      });
    },
  };

  return (
    <>
      <GoabContainer accent="thin">
        <h3>
          {getResourceValue({ key: "RESOURCES@firstNationStatus.title" })}
        </h3>
        <GoabSpacer vSpacing="l" />

        <GoabFormItem>
          <GoabRadioGroup
            name="isIndigenous"
            onChange={({name, value}) => {
              handleChange(name, value);
              // Needed for radio buttons
              setTimeout(() => form.validateForm());
            }}
            orientation="horizontal"
            value={fieldValues.isIndigenous}
          >
            <GoabRadioItem value="Y" label="Yes" />
            <GoabRadioItem value="N" label="No" />
          </GoabRadioGroup>
        </GoabFormItem>

        {fieldValues.isIndigenous === "Y" && (
          <>
            <GoabSpacer vSpacing="l" />
            <FirstNationStatusDetail
              form={firstNationStatusForm}
              getResourceValue={getResourceValue}
              pageResourceKey={null}
              setFormData={(updatedValues: any) => {
                Object.entries(updatedValues).forEach(([key, value]) => {
                  if (value !== undefined) {
                    form.setFieldValue(`FirstNationStatus.${key}`, value);
                  }
                });
              }}
              isGenerator={true}
            />

            <GoabSpacer vSpacing="l"></GoabSpacer>
            <GoabFormItem label="Do you live on reserve?">
              <GoabRadioGroup
                name="livesOnReserve"
                onChange={({name, value}) => {
                  handleChange(name, value);
                }}
                orientation="horizontal"
                value={fieldValues.livesOnReserve}
              >
                <GoabRadioItem value="Y" label="Yes" />
                <GoabRadioItem value="N" label="No" />
              </GoabRadioGroup>
            </GoabFormItem>
          </>
        )}
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
